import React from "react";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { CSVLink } from 'react-csv'

export const ExportXlsxCsv = ({ Data, fileName }) => {

  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  let fileExtension = '.xlsx';

  const exportToXLSX = (xlsxData, fileName, type) => {
    // let format_xlsx_data = []
    // if (xlsxData && xlsxData.length > 0) {
    //   // console.log(xlsxData)

    //   xlsxData = xlsxData.sort(function (a, b) {
    //     return new Date(b.SnsPublishTime) - new Date(a.SnsPublishTime);
    //   })

    //   xlsxData.forEach((item, index) => {
    //     let data = {
    //       'Email': item.SESDestinationAddress,
    //       'SENT_DATE': moment(item.SnsPublishTime).format("YYYY-MM-DD hh:mm a"),
    //       'Type': item.type,
    //       'postUid_List': item.postsUid.join(),
    //       'Delivered': item.Delivery ? moment(item.Delivery['SESDeliverTime']).format("YYYY-MM-DD hh:mm a") : '',
    //       'Opened': item.Open ? moment(item.Open['SESOpenTime']).format("YYYY-MM-DD hh:mm a") : '',
    //       'Clicked': item.Click ? moment(item.Click['SESClickTime']).format("YYYY-MM-DD hh:mm a") : ''
    //     }
    //     format_xlsx_data.push(data)
    //   })
    // }
    // console.log(format_xlsx_data)

    const ws = XLSX.utils.json_to_sheet(xlsxData);
    // if (type === 'csv') {
    //   fileExtension = '.csv'
    //   var csv = XLSX.utils.sheet_to_csv(ws);
    // }
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }

  return (
    // <Button variant="warning" onClick={(e) => exportToXLSX(Data, fileName)}>Export</Button>
    <div className="d-flex align-items-center">
      <CSVLink className="bg-dark export-btn" data={Data} filename={fileName + '.csv'}>CSV</CSVLink>
      {/* <button className="btn btn-success" onClick={(e) => exportToXLSX(Data, fileName, 'csv')}>Export to CSV</button> */}
      <button className="bg-dark export-btn" onClick={(e) => exportToXLSX(Data, fileName, 'xlsx')}>XLSX</button>
    </div>
  )
}